import React from 'react';
import PropTypes from 'prop-types';

import NotificationModal from 'bento-ordering/base/components/NotificationModal';
import PrimaryCta from 'components/Buttons/PrimaryCta';

function MenuItemNotOnCurrentMenuNotification({ closeModal }) {
  return (
    <NotificationModal
      title="Oops! This item is not available"
      body="This item is not available on the current menu."
      onClose={closeModal}
      fullWidth
    >
      <PrimaryCta label="OK, Got It" handleClick={closeModal} fullWidth />
    </NotificationModal>
  );
}

MenuItemNotOnCurrentMenuNotification.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default MenuItemNotOnCurrentMenuNotification;
